import { useContext, createContext, useEffect, useState } from "react";

import PropTypes from "prop-types";

import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import uiTypes from "@/view/constants/uiTypes";

const propTypes = {
  children: PropTypes.node,
  isLiteContent: PropTypes.bool,
  isPremiumContent: PropTypes.bool,
};

const UserContentUIContext = createContext();

export const UserContentUIContextProvider = ({
  children,
  isLiteContent,
  isPremiumContent,
}) => {
  const [uiType, setUiType] = useState();
  const { data: user } = useUser();
  const { isLiteUser, isAuthenticatedUser } = getUserProperties(user);

  useEffect(() => {
    if (isLiteUser && isLiteContent) setUiType(uiTypes.LITE);
    if (isLiteUser && isPremiumContent)
      setUiType(uiTypes.LITE_USER_PREMIUM_CONTENT);
    if (!isLiteUser && isPremiumContent) setUiType(uiTypes.PREMIUM);
    if (!isLiteUser && isLiteContent)
      setUiType(uiTypes.PREMIUM_USER_LITE_CONTENT);
    if (!isAuthenticatedUser) setUiType(uiTypes.UNAUTHENTICATED_USER);
  }, [isLiteContent, isLiteUser, isPremiumContent, isAuthenticatedUser]);

  return (
    <UserContentUIContext.Provider
      value={{
        uiType,
      }}
    >
      {children}
    </UserContentUIContext.Provider>
  );
};

UserContentUIContextProvider.propTypes = propTypes;

const useUserContentUIContext = () => {
  const userContentUIContext = useContext(UserContentUIContext);

  if (userContentUIContext === undefined) {
    throw new Error(
      "userContentUIContext must be used within a UserContentUIContextProvider.",
    );
  }

  return userContentUIContext;
};

export default useUserContentUIContext;
